import { render, staticRenderFns } from "./SMSPref.vue?vue&type=template&id=11346529&scoped=true"
import script from "./SMSPref.vue?vue&type=script&lang=ts"
export * from "./SMSPref.vue?vue&type=script&lang=ts"
import style0 from "./SMSPref.vue?vue&type=style&index=0&id=11346529&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11346529",
  null
  
)

export default component.exports